import React from 'react';
import { IconProps } from '../types';
import { DEFAULT_ICON_SIZE } from '../constants';

const NaviNewLogoIconWithText: React.FC<IconProps> = ({
    size = DEFAULT_ICON_SIZE,
    width = 120,
    height = 40,
    color = '#FA4F56',
    ...restProps
}) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox={`0 0 ${width} ${height}`}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...restProps}
        >
            <path
                d="M19.4822 16.1551C18.8979 15.5966 18.1194 15.2852 17.3109 15.2852H5.71429V34.2842H12.1425V21.4277H18.5708V32.1415C18.5708 33.3243 19.5307 34.2842 20.7135 34.2842H24.999V22.7719C24.999 21.9134 24.6476 21.0934 24.0277 20.4992L19.4822 16.1551Z"
                fill="#22D081"
            />
            <path
                d="M18.5708 5.71423V11.8568H28.1418V21.4277H34.2843V5.71423H18.5708Z"
                fill="#22D081"
            />
            <path
                d="M62.4529 15.9808C61.9758 15.5337 61.3473 15.2852 60.6945 15.2852H49.9978V34.2842H54.569V19.5707H61.7115V32.57C61.7115 33.5171 62.4787 34.2842 63.4257 34.2842H66.2827V20.6849C66.2827 19.9735 65.9885 19.295 65.4699 18.8093L62.4529 15.9808Z"
                fill="#3C0050"
            />
            <path d="M113.566 15.2852H108.995V34.2842H113.566V15.2852Z" fill="#3C0050" />
            <path
                d="M96.9954 32.2843L92.7099 15.2852H87.853L93.0628 33.0528C93.277 33.7828 93.947 34.2842 94.7084 34.2842H99.2839C100.045 34.2842 100.715 33.7828 100.93 33.0528L106.139 15.2852H101.282L96.9969 32.2843H96.9954Z"
                fill="#3C0050"
            />
            <path
                d="M82.1776 16.038C81.6948 15.5551 81.0419 15.2852 80.3591 15.2852H71.711V17.8565C71.711 18.8036 72.4781 19.5707 73.4252 19.5707H81.4248V22.7134H74.4351C73.7866 22.7134 73.1609 22.9591 72.6852 23.4005L70.2011 25.7075C69.7068 26.1675 69.4254 26.8117 69.4254 27.4874V29.3716C69.4254 30.0458 69.7054 30.6901 70.1996 31.1486L72.8281 33.5957C73.3038 34.0385 73.9294 34.2856 74.5808 34.2856H85.7117V20.6377C85.7117 19.9563 85.4403 19.3021 84.9589 18.8193L82.179 16.0394L82.1776 16.038ZM81.4248 30.4273H73.7109V26.1418H81.4248V30.4273Z"
                fill="#3C0050"
            />
        </svg>
    );
};

export default React.memo(NaviNewLogoIconWithText);
